export const KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: 'Space',
  TAB: 'Tab',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
};

export const KEY_VALUES = {
  [KEYS.ENTER]: KEYS.ENTER,
  [KEYS.ESCAPE]: KEYS.ESCAPE,
  [KEYS.TAB]: KEYS.TAB,
  [KEYS.ARROW_UP]: KEYS.ARROW_UP,
  [KEYS.ARROW_DOWN]: KEYS.ARROW_DOWN,
  ' ': KEYS.SPACE,
  9: KEYS.TAB,
  13: KEYS.ENTER,
  27: KEYS.ESCAPE,
  32: KEYS.SPACE,
} as const;
